// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/lazyload.js'; import './autoload/menu.js'; // eslint-disable-line

// Import local dependencies
import { scrollIntoViewWithOffset } from './utils/helpers';

// Import plugins
import 'jquery-match-height';
import 'slick-carousel';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';

// Import scripts from Custom ACF Gutenberg blocks
import '../gutenberg/blocks/acf-accordion/index.js'; import '../gutenberg/blocks/acf-breadcrumbs/index.js'; import '../gutenberg/blocks/acf-card-image-link/index.js'; import '../gutenberg/blocks/acf-card-text/index.js'; import '../gutenberg/blocks/acf-carousel/index.js'; import '../gutenberg/blocks/acf-counter/index.js'; import '../gutenberg/blocks/acf-cta/index.js'; import '../gutenberg/blocks/acf-example/index.js'; import '../gutenberg/blocks/acf-layout-options/index.js'; import '../gutenberg/blocks/acf-post-grid/index.js'; import '../gutenberg/blocks/acf-quick-link/index.js'; import '../gutenberg/blocks/acf-svg/index.js'; import '../gutenberg/blocks/acf-tabs/index.js'; import '../gutenberg/blocks/acf-vcard-grid/index.js'; import '../gutenberg/blocks/acf-yt-embed/index.js'; // eslint-disable-line

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');

  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Set CSS variable for header height
 */

const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
};

/**
 * Scripts which runs after DOM load
 */
$(function () {
  const $header = $('.header');

  searchFormToggler($header);
  mobileMenuHandler($header);
  backToTopBtn();

  if ($('#gf-modal').length) {
    gFormActionLoadPdf();
    gFormActionReloadPageOnPdf();
  }

  /**
   * Make elements equal height
   */
  if ($('.matchHeight').length) {
    $('.matchHeight').matchHeight();
  }

  /**
   * Homepage/layout image slider (enable_slider on layout-options block)
   */
  if ($('.homeslickslider').length && typeof $.fn.slick === 'function') {
    $('.homeslickslider').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 8000,
      speed: 800,
      fade: true,
      cssEase: 'linear',
      adaptiveHeight: true,
      pauseOnHover: false,
      pauseOnFocus: false,
    });
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    targets: '[data-scroll]',
    threshold: 0.8,
    once: true,
    onShown: function (element) {
      element.setAttribute('data-scroll', 'in');
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (_, formId) {
    let target = document.getElementById(
      `gform_confirmation_wrapper_${formId}`
    );

    if (target) {
      scrollIntoViewWithOffset(target, 100);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // Preloader
  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  // Create CSS variable for header height
  setHeaderHeight();
  animateCounters();

  setTimeout(() => {
    addFeaturedSpanToBlockquote();
  }, 100);
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  resizeVideo();

  // Create CSS variable for header height
  setHeaderHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here

  toggleFixedHeader();
});

/**
 * Search Form Toggler
 */
function searchFormToggler($header) {
  const $searchBtn = $header.find('.js-search-button-action');
  const $searchForm = $header.find('.js-search-form');
  function bindEvents() {
    $searchBtn.off('click');
    $searchForm.off('click');
    $(document).off('click.searchForm');

    if ($(window).width() >= 1024) {
      $searchBtn.on('click', function (e) {
        e.stopPropagation();
        $searchForm.toggleClass('is-active');
      });

      $searchForm.on('click', function (e) {
        e.stopPropagation();
      });

      $(document).on('click.searchForm', function () {
        $searchForm.removeClass('is-active');
      });
    } else {
      $searchForm.addClass('is-active');
    }
  }

  bindEvents();

  $(window).on('resize', function () {
    bindEvents();
  });
}

/**
 * Mobile Burger menu
 */
function mobileMenuHandler($header) {
  const $headerMenu = $('.header-menu');
  const $menuItems = $headerMenu.find('li.menu-item-has-children');
  const $burgerBtn = $('.menu-icon');

  $menuItems.each(function () {
    if (!$(this).children('.dropdown-toggle').length) {
      $(this).append('<div class="dropdown-toggle"></div>');
    }
  });

  $headerMenu.on('click touchstart', '.dropdown-toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $parent = $(this).closest('li');
    const $submenu = $parent.children('.submenu');

    $headerMenu
      .find('li.open')
      .not($parent)
      .removeClass('open')
      .children('.submenu')
      .slideUp(250);

    $parent.toggleClass('open');
    $submenu.stop(true, true).slideToggle(250);
  });

  $burgerBtn.on('click', function () {
    $('body').toggleClass('menu-open');
    $header.toggleClass('menu-is-active');
  });
}

/**
 * Action on scrolling to toggle fixed header
 */
function toggleFixedHeader() {
  const $header = $('.header');

  if (!$header.length) {
    return;
  }

  const scrollOffset = 10;

  if ($(window).scrollTop() > scrollOffset) {
    $header.addClass('fixed-top');
    return;
  }

  $header.removeClass('fixed-top');
}

/**
 * Animate Counters
 */
function animateCounters(selector = '.count-animate', duration = 3000) {
  const $elements = $(selector);

  $elements.css({
    opacity: 0,
    transition: 'opacity 1s ease',
  });

  function wrapNumbers($el) {
    const html = $el.html();

    const wrapped = html.replace(/(\d+(?:[.,]\d+)?)/g, (match) => {
      return `<span class="count-animate-number" data-value="${match}">${match}</span>`;
    });

    $el.html(wrapped);
  }

  function animateNumber($numEl) {
    if ($numEl.data('animated')) return;
    $numEl.data('animated', true);

    const raw = $numEl.data('value').toString();

    let numStr = raw.replace(/,/g, '').replace(',', '.');
    const target = parseFloat(numStr);

    const isFloat = numStr.includes('.') || numStr.includes(',');
    const decimals = isFloat ? numStr.split('.')[1]?.length || 2 : 0;

    const startVal = 0;
    const startTime = performance.now();

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function tick(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = easeOutCubic(progress);
      const current = startVal + (target - startVal) * eased;

      const formatted = isFloat
        ? current.toFixed(decimals)
        : Math.round(current);

      $numEl.text(formatted);

      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function runAnimation($el) {
    if ($el.data('animated-container')) return;
    $el.data('animated-container', true);

    const $numbers = $el.find('.count-animate-number');
    $numbers.each(function () {
      animateNumber($(this));
    });

    $el.css('opacity', 1);
  }

  $elements.each(function () {
    wrapNumbers($(this));
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          runAnimation($(entry.target));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  $elements.each(function () {
    observer.observe(this);
  });
}

function addFeaturedSpanToBlockquote() {
  const blockquotes = document.querySelectorAll('.wp-block-quote');

  if (!blockquotes.length) return;

  blockquotes.forEach((blockquote) => {
    // Проверяем, не добавляли ли уже
    if (blockquote.querySelector('.featured-span')) return;

    const outerSpan = document.createElement('span');
    outerSpan.classList.add('featured-span');

    const innerSpan = document.createElement('span');
    innerSpan.classList.add('inner-span');

    outerSpan.appendChild(innerSpan);

    // Вставляем в конец blockquote
    blockquote.appendChild(outerSpan);
  });
}

/**
 * Wp block cover overlay is handled in CSS
 * (.is-style-hero-overlay-inner) to avoid layout shift on mobile.
 */

/**
 * Gravity Form (#3) action for download PDF
 */
function gFormActionLoadPdf() {
  const $modal = $('#gf-modal');
  if (!$modal.length) return;

  const $form = $modal.find('form');

  // Close modal helper
  function close_modal() {
    $modal.removeClass('is-active');
    window.location.reload();
  }

  // Attach click handlers to PDF buttons
  $('.js-gf-modal-action').each(function () {
    const $grid = $(this);

    $grid.find('.preview__content .button').on('click', function (e) {
      e.preventDefault();

      const pdfLink = $(this).data('pdf');
      if (!pdfLink) return;

      // Reset form first
      if ($form.length) {
        $form[0].reset();
      }

      // Open modal
      $modal.addClass('is-active');

      // Set PDF field
      const $input = $modal.find('.js-link-pdf input, .js-link-pdf textarea');
      if ($input.length) {
        $input.val(pdfLink).trigger('change').focus();
      }
    });
  });

  // Close on overlay click
  $modal.on('click', function (e) {
    if ($(e.target).is($modal)) {
      close_modal();
    }
  });

  // Close on ESC
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      close_modal();
    }
  });

  // Close by cross button
  $modal.find('.gf-modal__close-button').on('click', function (e) {
    e.preventDefault();
    close_modal();
  });
}

/**
 * Gravity Form (#3) action for open PDF
 */

function gFormActionReloadPageOnPdf() {
  const links = document.querySelectorAll('.gform_confirmation_message_3_link');
  links.forEach(function (link) {
    link.addEventListener('click', function () {
      console.log('faasdf');
      setTimeout(function () {
        location.reload();
      }, 200);
    });
  });
}

/**
 * Back to top tbn action
 */

function backToTopBtn() {
  const backToTopInner = document.querySelector('.back-to-top__inner');
  const backToTopBtn = document.querySelector('.js-back-to-top');

  if (!backToTopInner || !backToTopBtn) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 150) {
      backToTopInner.style.opacity = '1';
      backToTopInner.style.visibility = 'visible';
    } else {
      backToTopInner.style.opacity = '0';
      backToTopInner.style.visibility = 'hidden';
    }
  });

  backToTopBtn.addEventListener('click', (e) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    backToTopInner.style.opacity = '0';
    backToTopInner.style.visibility = 'hidden';
  });
}
